import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaApolloExecute" */ './lazyIndex'),
    { name: 'OwaApolloExecute' }
);

export const lazyExecute: LazyAction<typeof lazyIndex.execute, typeof lazyModule> = new LazyAction(
    lazyModule,
    m => m.execute
);
export const lazySubscribe: LazyAction<typeof lazyIndex.subscribe, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.subscribe);
export const lazyResetStateForTests: LazyAction<
    typeof lazyIndex.resetStateForTests,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.resetStateForTests);
export const lazyPrecompile: LazyAction<typeof lazyIndex.precompile, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.precompile);
